import { ActionIcon, Tooltip } from "@mantine/core";

import { getNexSortBy } from "./utils";

import { IconArrowDown, IconArrowUp } from "@/components/icons";

import type { ActionIconProps } from "@mantine/core";
import type { IconProps } from "@tabler/icons-react";
import type { FC } from "react";
import type { ListTableColumnSortBy } from "../../types";

export type ListTableColumnSorterProps = {
  iconProps?: IconProps;
  onSortChange?: (sortBy?: ListTableColumnSortBy) => void;
  sortBy?: ListTableColumnSortBy;
  tooltip?: string;
} & Pick<ActionIconProps, "loading" | "radius" | "size">;

export const ListTableColumnSorter: FC<ListTableColumnSorterProps> = ({
  iconProps = { size: 24 },
  onSortChange,
  sortBy,
  tooltip,
  ...props
}) => {
  const Icon = sortBy === "desc" ? IconArrowUp : IconArrowDown;
  const c = sortBy === undefined ? "dimmed" : undefined;
  const color = sortBy === undefined ? "secondary" : "primary";

  return (
    <Tooltip
      label={tooltip}
      disabled={tooltip === undefined}
      events={{ hover: true, focus: true, touch: true }}
    >
      <ActionIcon
        c={c}
        color={color}
        variant="subtle"
        size="sm"
        onClick={() => onSortChange?.(getNexSortBy(sortBy))}
        {...props}
      >
        <Icon {...iconProps} />
      </ActionIcon>
    </Tooltip>
  );
};
